import { defineStore } from 'pinia'
import { logout, refreshToken } from "@/services/api/auth.js";
import { getMePermissionsManagement } from "@/services/api/permissionManagement.js";

let refreshTimeout = null;

export const useAuthStore = defineStore('auth', {
    state: () => ({
        permissions: JSON.parse(localStorage.getItem('permissions') || 'null'),
        currentCorp: null,
        loadingPermissions: false,
        authenticationEntryPath: localStorage.getItem('authenticationEntryPath') || '/',
        companySetupRedirectRoute: '/home',
    }),

    getters: {
        isAdmin: (state) => {
            return state.permissions?.admin?.includes("*") &&
                state.permissions?.allow?.includes("*");
        },
        signInRoute: (state) => state.authenticationEntryPath,
    },

    actions: {
        setAuthenticationEntryPath(path) {
            this.authenticationEntryPath = path === '/rhdigital' ? '/rhdigital' : '/';
            localStorage.setItem('authenticationEntryPath', this.authenticationEntryPath);
        },

        setCompanySetupRedirectRoute(route) {
            this.companySetupRedirectRoute = route || '/home';
        },

        clearCompanySetupRedirectRoute() {
            this.companySetupRedirectRoute = '/home';
        },

        setCurrentCorp(corp) {
            this.currentCorp = corp;
        },

        async fetchPermissions() {
            try {
                const response = await getMePermissionsManagement();

                this.permissions = response;

                localStorage.setItem('permissions', JSON.stringify(response));

            } catch (err) {
                console.error("Error Permissions: ", err);
            }
        },

        scheduleTokenRefresh() {
            clearTimeout(refreshTimeout);

            const exp = localStorage.getItem('tokenExp');
            if (!exp) return;

            const expTime = Number(exp) * 1000;
            const now = Date.now();

            const refreshIn = expTime - now - (60 * 1000);

            if (refreshIn <= 0) {
                refreshTimeout = setTimeout(async () => {
                    try {
                        await refreshToken();
                        this.scheduleTokenRefresh();
                    } catch {
                        await logout({ reason: 'expired' });
                    }
                }, 0);
                return;
            }

            refreshTimeout = setTimeout(async () => {
                try {
                    await refreshToken();
                    this.scheduleTokenRefresh();
                } catch (e) {
                    console.error('Erro ao renovar token', e);
                    await logout({ reason: 'expired' });
                }
            }, refreshIn);
        }
    }
});
